import axios from "../../../axios";
const appUrl: string | undefined = process.env.REACT_APP_API_URL;
export const getDeliveryInfoList = () => {
  const response = axios.get(`orders/delivery-slots/`);
  return response;
};

export function paymentCheckout(payload: any) {
  const response = axios.post(`orders/checkout/`, payload);
  return response;
}

export function paymentCustomerOrderCheckout(payload: any) {
  const response = axios.post(`orders/custom_order_checkout/`, payload);
  return response;
}

export function paymentVerify(payload: any) {
  const response = axios.post(`orders/double/verify/`, payload);
  return response;
}
export function paymentVerification(payload: any) {
  const response = axios.post(`orders/verifypayment/`, payload);
  return response;
}

export const getPastOrderDataDetails = (uuid: any) => {
  const response = axios.get(`orders/past-orders/${uuid}`);
  return response;
};

export const getCouponList = () => {
  const response = axios.post(`orders/coupons/`);
  return response;
};

export const getAddressChange = (payload: any) => {
  const response = axios.post(`orders/address-change/`, payload);
  return response;
};
export const getBillDetails = (orderid: any) => {
  const response = axios.post(
    `${appUrl}orders/download-bill/${orderid}/`,
    {},
    {
      responseType: "blob",
    }
  );
  return response;
};

export function getWhatsapCheck() {
  const response = axios.get(`accounts/check-opt-in/`);
  return response;
}
